import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PortalConteosComponent } from './portal-conteos.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatDividerModule} from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {Surveyuser} from './portal-conteos.component';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatStepperModule} from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import {MatTableModule} from '@angular/material/table';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTreeModule} from '@angular/material/tree';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatMenuModule} from '@angular/material/menu';
import {MatTabsModule} from '@angular/material/tabs';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatButtonToggleModule} from '@angular/material/button-toggle';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';
// TRANSLATE

import { ChartsModule } from 'ng2-charts';
import { DatePipe } from '@angular/common';
const rutas: Routes = [
    // trust index
    {
        path     : 'portalControl',
        component: PortalConteosComponent,
        canActivate: [AuthGuard]
    },
];

@NgModule({
  declarations: [PortalConteosComponent,Surveyuser],
  imports: [
    CommonModule,
      FlexLayoutModule,
      RouterModule.forChild(rutas),
      MatDividerModule,
      TranslateModule,
      MatFormFieldModule,
      MatIconModule,
      MatButtonModule,
      MatProgressBarModule,
      MatSelectModule,
      MatProgressSpinnerModule,
      ChartsModule,
      MatStepperModule,
      FormsModule,
      ReactiveFormsModule,
      MatInputModule,
      MatCheckboxModule,
      MatSidenavModule,
      MatTooltipModule,
      MatTableModule,
      MatTableModule,
      MatListModule,
      MatTreeModule,
      MatPaginatorModule,
      MatSortModule,
      MatMenuModule,
      MatTabsModule,
      MatGridListModule,
      MatButtonToggleModule
  ],entryComponents:[
    Surveyuser
  ],providers: [DatePipe],
})
export class PortalConteosModule { }
